var pug = require("!../../../../../../node_modules/.pnpm/pug@2.0.4/node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;;var locals_for_with = (locals || {});(function (isDisableEXTA, isStandardTextAd, schemaI18n, statusTypeClass, value) {if (isDisableEXTA) {
pug_html = pug_html + "\u003Cdiv\u003E";
if (value) {
pug_html = pug_html + "\u003Cbr\u003E\u003Cdiv class=\"ad-type trigger-popup\"\u003E\u003Cspan" + (pug.attr("class", pug.classes(["status-column","clickable",`${statusTypeClass} ads_type_exta_deprecate_reasons`], [false,false,true]), false, true)+" tabindex=\"0\" role=\"button\"") + "\u003E" + (pug.escape(null == (pug_interp = schemaI18n.enum('AdType', value)) ? "" : pug_interp)) + "\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E";
}
else {
pug_html = pug_html + (pug.escape(null == (pug_interp = ' ') ? "" : pug_interp));
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E";
}
else
if (isStandardTextAd) {
pug_html = pug_html + "\u003Cdiv\u003E";
if (value) {
pug_html = pug_html + "\u003Cbr\u003E\u003Cdiv class=\"ad-type trigger-popup\"\u003E\u003Cspan" + (pug.attr("class", pug.classes(["status-column","clickable",`${statusTypeClass} ads_type_sta_deprecate_reasons`], [false,false,true]), false, true)+" tabindex=\"0\" role=\"button\"") + "\u003E" + (pug.escape(null == (pug_interp = schemaI18n.enum('AdType', value)) ? "" : pug_interp)) + "\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E";
}
else {
pug_html = pug_html + (pug.escape(null == (pug_interp = ' ') ? "" : pug_interp));
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E";
}
else {
if (value) {
pug_html = pug_html + "\u003Cspan\u003E" + (pug.escape(null == (pug_interp = schemaI18n.enum('AdType', value)) ? "" : pug_interp)) + "\u003C\u002Fspan\u003E";
}
else {
pug_html = pug_html + (pug.escape(null == (pug_interp = ' ') ? "" : pug_interp));
}
}}.call(this,"isDisableEXTA" in locals_for_with?locals_for_with.isDisableEXTA:typeof isDisableEXTA!=="undefined"?isDisableEXTA:undefined,"isStandardTextAd" in locals_for_with?locals_for_with.isStandardTextAd:typeof isStandardTextAd!=="undefined"?isStandardTextAd:undefined,"schemaI18n" in locals_for_with?locals_for_with.schemaI18n:typeof schemaI18n!=="undefined"?schemaI18n:undefined,"statusTypeClass" in locals_for_with?locals_for_with.statusTypeClass:typeof statusTypeClass!=="undefined"?statusTypeClass:undefined,"value" in locals_for_with?locals_for_with.value:typeof value!=="undefined"?value:undefined));;return pug_html;};
module.exports = template;